import React, { CSSProperties } from "react";

export default function IconVelavuFeedback(props: {
	className?: string;
	style?: CSSProperties;
	color?: string;
	size?: number;
}) {
	return (
		<svg
			className={props.className}
			style={props.style}
			xmlns="http://www.w3.org/2000/svg"
			width={props.size ?? 24}
			height={props.size ?? 24}
			viewBox="0 0 24 24"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4 10C4 7.79086 5.59188 6 7.55556 6H16.4444C18.4081 6 20 7.79086 20 10V14C20 16.2091 18.4081 18 16.4444 18H11L8 21V18H7.55556C5.59188 18 4 16.2091 4 14V10ZM7.55556 8H16.4444C17.4263 8 18.2222 8.89543 18.2222 10V14C18.2222 15.1046 17.4263 16 16.4444 16H7.55556C6.57372 16 5.77778 15.1046 5.77778 14V10C5.77778 8.89543 6.57372 8 7.55556 8Z"
				fill={props.color ?? "black"}
			/>
			<path
				d="M8 10.5C8 10.2239 8.22386 10 8.5 10H15.5C15.7761 10 16 10.2239 16 10.5C16 10.7761 15.7761 11 15.5 11H8.5C8.22386 11 8 10.7761 8 10.5Z"
				fill={props.color ?? "black"}
			/>
			<path
				d="M8 13.5C8 13.2239 8.22386 13 8.5 13H13.5C13.7761 13 14 13.2239 14 13.5C14 13.7761 13.7761 14 13.5 14H8.5C8.22386 14 8 13.7761 8 13.5Z"
				fill={props.color ?? "black"}
			/>
		</svg>
	);
}
